import { render, staticRenderFns } from "./Manufactures.vue?vue&type=template&id=38d46e70&scoped=true&"
import script from "./Manufactures.vue?vue&type=script&lang=js&"
export * from "./Manufactures.vue?vue&type=script&lang=js&"
import style0 from "./Manufactures.vue?vue&type=style&index=0&id=38d46e70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d46e70",
  null
  
)

export default component.exports